import React, { useEffect, useState, useRe } from 'react';
import { Container, Table } from 'react-bootstrap';
import classes from './style.module.css'
import Match from './Match'
import { MATCH_TABLE_COLUMNS_STATIC, MATCH_TABLE_COLUMNS_DYNAMIC, MATCH_TABLE_COLUMNS_RESULTS, MATCH_TABLE_COLUMNS_STATS_HOME, MATCH_TABLE_COLUMNS_STATS_AWAY, MATCH_TABLE_COLUMNS_CALCULATED, TOTAL, HOME, AWAY, MATCH_TABLE_COLUMNS_ODDS } from '../../constants/Constants'
import { connect } from "react-redux"
import { SET_SOCCER_MATCHES_STATE, SET_SELECTION_STATE } from "../../redux/actions"
import { getMatchesByDate } from "../../service/backend-api-service"
import { logInfo } from "../../util/log/logger"
import { getPreviousNthDayStr } from '../../util/date/date-utils';
import sortIconImage from "../../assets/images/sort_both.png"
import Spinner from "../UI/Spinner"
import jp from 'jsonpath'



const MatchTable = (props) => {
    const LOADING = 0;
    const LOADED = 1;
    const ZERO_ELEMENT = 2;

    const [sortOrder, setSortOrder] = useState(true) // true - ascending and false - descending
    const [sortColumn, setSortColumn] = useState(null)
    const [loadingState, setLoadingState] = useState(0)
    const [itemList, setItemList] = useState([])

    const staticColumns = []
    for (let value in MATCH_TABLE_COLUMNS_STATIC) staticColumns.push(MATCH_TABLE_COLUMNS_STATIC[value])

    const dynamicColumns = []
    for (let value in MATCH_TABLE_COLUMNS_DYNAMIC) dynamicColumns.push(MATCH_TABLE_COLUMNS_DYNAMIC[value])

    const resultColumns = []
    const calculatedColumns = []
    for (let value in MATCH_TABLE_COLUMNS_CALCULATED) calculatedColumns.push(MATCH_TABLE_COLUMNS_CALCULATED[value])

    const oddColumns = []
    for (let value in MATCH_TABLE_COLUMNS_ODDS) oddColumns.push(MATCH_TABLE_COLUMNS_ODDS[value])

    const homeColumns = []
    for (let value in MATCH_TABLE_COLUMNS_STATS_HOME) homeColumns.push(MATCH_TABLE_COLUMNS_STATS_HOME[value])

    const awayColumns = []
    for (let value in MATCH_TABLE_COLUMNS_STATS_AWAY) awayColumns.push(MATCH_TABLE_COLUMNS_STATS_AWAY[value])

    const finalColumns = [...staticColumns, ...dynamicColumns];

    const sortIconClickedHandler = columnId => {
        logInfo(`LeagueTable | sortIconClickedHandler | called. column id: ${columnId}`)
        setSortColumn(columnId)
        if (sortColumn === columnId) setSortOrder(!sortOrder)
    }

    const getToolTip = column => {
        let toolTip = null
        if (homeColumns.includes(column)) {
            if (props.selectionState.home === HOME)
                toolTip = <span className={classes.TooltipText}>{column.teamToolTip}</span>
            else
                toolTip = <span className={classes.TooltipText}>{column.totalToolTip}</span>
        } else if (awayColumns.includes(column)) {
            if (props.selectionState.away === AWAY)
                toolTip = <span className={classes.TooltipText}>{column.teamToolTip}</span>
            else
                toolTip = <span className={classes.TooltipText}>{column.totalToolTip}</span>
        } else if (calculatedColumns.includes(column) || oddColumns.includes(column)) {
            toolTip = <span className={classes.TooltipText}>{column.toolTip}</span>
        }
        return toolTip;
    }

    const tableHeaders = finalColumns.map(column => {
        let sortIcon = null
        let hide = null;
        if (column.id !== MATCH_TABLE_COLUMNS_STATIC.ROW_NUM.id && column.id !== MATCH_TABLE_COLUMNS_STATIC.COUNTRY_FLAG.id)
            sortIcon = <img src={sortIconImage} alt="Sort" onClick={() => sortIconClickedHandler(column.id)} />

        if (column.id == MATCH_TABLE_COLUMNS_STATS_HOME.H_CORNER_PER_MATCH.id ||
            column.id == MATCH_TABLE_COLUMNS_STATS_HOME.H_CORNER_AGAINST_PER_MATCH.id ||
            column.id == MATCH_TABLE_COLUMNS_STATS_HOME.H_CORNER_TTL_PER_MATCH.id ||
            column.id == MATCH_TABLE_COLUMNS_STATS_HOME.H_CORNER_OVER_9_5_PER_MATCH.id ||
            column.id == MATCH_TABLE_COLUMNS_STATS_HOME.H_CORNER_OVER_10_5_PER_MATCH.id ||
            column.id == MATCH_TABLE_COLUMNS_STATS_HOME.H_CORNER_OVER_11_5_PER_MATCH.id ||
            column.id == MATCH_TABLE_COLUMNS_STATS_HOME.H_CORNER_OVER_12_5_PER_MATCH.id ||
            column.id == MATCH_TABLE_COLUMNS_STATS_HOME.H_CORNER_OVER_13_5_PER_MATCH.id ||

            column.id == MATCH_TABLE_COLUMNS_STATS_AWAY.A_CORNER_PER_MATCH.id ||
            column.id == MATCH_TABLE_COLUMNS_STATS_AWAY.A_CORNER_AGAINST_PER_MATCH.id ||
            column.id == MATCH_TABLE_COLUMNS_STATS_AWAY.A_CORNER_TTL_PER_MATCH.id ||
            column.id == MATCH_TABLE_COLUMNS_STATS_AWAY.A_CORNER_OVER_9_5_PER_MATCH.id ||
            column.id == MATCH_TABLE_COLUMNS_STATS_AWAY.A_CORNER_OVER_10_5_PER_MATCH.id ||
            column.id == MATCH_TABLE_COLUMNS_STATS_AWAY.A_CORNER_OVER_11_5_PER_MATCH.id ||
            column.id == MATCH_TABLE_COLUMNS_STATS_AWAY.A_CORNER_OVER_12_5_PER_MATCH.id ||
            column.id == MATCH_TABLE_COLUMNS_STATS_AWAY.A_CORNER_OVER_13_5_PER_MATCH.id ||

            column.id == MATCH_TABLE_COLUMNS_RESULTS.RESULT_FT.id ||
            column.id == MATCH_TABLE_COLUMNS_ODDS.ODDS_HOME_TEAM.id ||
            column.id == MATCH_TABLE_COLUMNS_ODDS.ODDS_AWAY_TEAM.id
        ) {
            hide = 'none'
        }


        const toolTip = getToolTip(column)


        return (
            <th key={column.id} style={{ display: hide }} className={classes.Tooltip}>
                {toolTip}
                {column.description} {sortIcon}
            </th>
        );
    })



    const getAverageValue = (a, b) => {
        let result = "-"
        if (a !== null && b !== null && a !== "-" && b !== "-") {
            result = (a + b) / 2
            result = result.toFixed(2)
        }
        return result
    }


    useEffect(() => {
        const fetchData = async () => {
            const itemList = props.soccerMatchesState.filter(filerByTier).map((item, index) => {
                const itemKey = item.id
                return (
                    <Match key={itemKey} finalColumns={finalColumns} item={item} index={index} home={props.selectionState.home} away={props.selectionState.away} />
                )
            });
            setItemList(itemList)
        }
        fetchData()
    }, [props.soccerMatchesState, props.tier])

    const compare = (a, b) => {
        if (a === b) return 0
        if (a === null || a === "-") return 1
        if (b === null || b === "-") return -1
        if (sortOrder) return a < b ? -1 : 1;
        else return a < b ? 1 : -1;
    }

    const compareObject = (a, b, jsonFieldId) => {
        if (a === b) return 0
        if (a === null) return 1
        if (b === null) return -1
        a = a[jsonFieldId]
        b = b[jsonFieldId]
        if (a === null || a === "-") return 1
        if (b === null || b === "-") return -1
        if (sortOrder) return a < b ? -1 : 1;
        else return a < b ? 1 : -1;
    }

    const compareOddWithJsonPath = (a, b, jsonPath) => {
        if (a === b) return 0
        if (a === null) return 1
        if (b === null) return -1
        //Create xpath
        const aData = jp.query(a, '$..oddResponses[?(@.name == "Bet365")]' + "." + jsonPath);
        const bData = jp.query(b, '$..oddResponses[?(@.name == "Bet365")]' + "." + jsonPath);
        let aValue = Number(aData);
        let bValue = Number(bData);
        if (sortOrder) return aValue < bValue ? -1 : 1;
        else return aValue < bValue ? 1 : -1;
    }


    const updateCalculatedColumns = matches => {
        logInfo(`MatchTable | updateCalculatedColumns | update calculated columns. count: ${matches.length}`)
        matches = matches.map(match => {
            match.combGoalsScoredConc = "-"
            match.combOverTwoPointFive = "-"
            match.combBtts = "-"
            if (match.homeStat !== null && match.awayStat !== null) {
                const cellValueCombGoalsScoredConc = getAverageValue(props.selectionState.home === HOME ? match.homeStat.avgGoalsScoredConc : match.homeStat.avgGoalsScoredConcTotal,
                    props.selectionState.away === AWAY ? match.awayStat.avgGoalsScoredConc : match.awayStat.avgGoalsScoredConcTotal)
                match.combGoalsScoredConc = !isNaN(cellValueCombGoalsScoredConc) ? parseFloat(cellValueCombGoalsScoredConc) : "-"

                const cellValueCombOverTwoPointFive = getAverageValue(props.selectionState.home === HOME ? match.homeStat.overTwoPointFiveGoals : match.homeStat.overTwoPointFiveGoalsTotal,
                    props.selectionState.away === AWAY ? match.awayStat.overTwoPointFiveGoals : match.awayStat.overTwoPointFiveGoalsTotal)
                match.combOverTwoPointFive = !isNaN(cellValueCombOverTwoPointFive) ? parseFloat(cellValueCombOverTwoPointFive) : "-"

                const cellValueCombBtts = getAverageValue(props.selectionState.home === HOME ? match.homeStat.bothTeamsScored : match.homeStat.bothTeamsScoredTotal,
                    props.selectionState.away === AWAY ? match.awayStat.bothTeamsScored : match.awayStat.bothTeamsScoredTotal)
                match.combBtts = !isNaN(cellValueCombBtts) ? parseFloat(cellValueCombBtts) : "-"
            }

            if (match.homeStat !== null) {
                for (let key in match.homeStat) {
                    if (match.homeStat[key] === null) {
                        match.homeStat[key] = "-"
                    }
                }
            }

            if (match.awayStat !== null) {
                for (let key in match.awayStat) {
                    if (match.awayStat[key] === null) {
                        match.awayStat[key] = "-"
                    }
                }
            }


            return match
        })
        return matches
    }

    function filerByTier(match) {
        console.log("filtering..." + match.tier);
        console.log("current tier" + props.tier);
        if (props.tier.indexOf("All") > - 1 || props.tier.length == 0) {
            return true;
        }
        return props.tier.includes(match.tier[0]);
    }

    useEffect(() => {
        const fetchData = async () => {
            setLoadingState(LOADING)
            logInfo("MatchTable | useEffect | called.")
            let date = props.selectionState.selectionDate
            logInfo(`MatchTable | useEffect | date: ${date}.`)
            let matches = await getMatchesByDate(date);
            //matches.filter(filerByTier);  
            if (matches.length === 0) {
                const currentDate = getPreviousNthDayStr(0)
                if (date === currentDate) {
                    date = getPreviousNthDayStr(1)
                    logInfo(`MatchTable | useEffect set selection date to previous date | date: ${date}.`)
                    const selectionState = { ...props.selectionState }
                    selectionState.selectionDate = date
                    props.setSelectionState(selectionState)
                }

            }
            logInfo(`MatchTable | useEffect | matches loaded. count: ${matches.length}`)
            matches = updateCalculatedColumns(matches)
            props.setSoccerMatchesState(matches)
            if (matches.length > 0) {
                setSortColumn(MATCH_TABLE_COLUMNS_STATIC.TIME.id)
                setLoadingState(LOADED)
            }
            else setLoadingState(LOADED)
        }
        fetchData()
    }, [props.selectionState.selectionDate])

    useEffect(() => {
        if (sortColumn != null) {
            let soccerMatchesState = [...props.soccerMatchesState]
            const topLevelColumns = [...staticColumns, ...calculatedColumns, ...resultColumns]
            let columnDefinition = topLevelColumns.find(element => element.id === sortColumn)
            let subField = null;
            let jsonPath = null;
            let jsonFieldSuffix = ""
            if (columnDefinition === undefined) {
                columnDefinition = homeColumns.find(element => element.id === sortColumn)
                if (columnDefinition === undefined) {
                    columnDefinition = awayColumns.find(element => element.id === sortColumn)
                    subField = "awayStat"
                    if (props.selectionState.away === TOTAL) jsonFieldSuffix = "Total"
                }

                if (columnDefinition === undefined) {
                    columnDefinition = oddColumns.find(element => element.id === sortColumn);
                    jsonPath = columnDefinition.jsonPath;
                    subField = null;
                } else {
                    subField = "homeStat"
                    if (props.selectionState.home === TOTAL) jsonFieldSuffix = "Total"
                }
            }
            const jsonFieldId = columnDefinition.jsonFieldId + jsonFieldSuffix
            logInfo(`Matches | useEffect | sorting the table data: sort column: ${sortColumn}, sort order: ${sortOrder}, leagues count: ${soccerMatchesState.length}, jsonFieldId: ${jsonFieldId}, subField: ${subField}`)

            if (soccerMatchesState.length > 0) {
                soccerMatchesState = updateCalculatedColumns(soccerMatchesState)
                soccerMatchesState.sort((a, b) => {
                    if (jsonPath != null) {
                        return compareOddWithJsonPath(a[jsonFieldId], b[jsonFieldId], jsonPath);
                        //    return compare(a[jsonFieldId], b[jsonFieldId]);
                    } else if (subField === null) {
                        return compare(a[jsonFieldId], b[jsonFieldId]);
                    } else {
                        return compareObject(a[subField], b[subField], jsonFieldId);
                    }
                });
                props.setSoccerMatchesState(soccerMatchesState)
            }
        }
    }, [props.selectionState.home, props.selectionState.away])

    let contentBody = null



    if (loadingState === LOADING) {
        contentBody = <Spinner />
    } else if (loadingState === ZERO_ELEMENT) {
        contentBody = <Spinner />
    } else {
        contentBody =
            <Table id="matchesTable" style={{ marginTop: '-1px' }} striped bordered hover size="sm">
                <thead>
                    <tr>
                        {tableHeaders}
                    </tr>
                </thead>
                <tbody>
                    {itemList}
                </tbody>
            </Table>

    }


    return (
        <Container fluid className={classes.MatchTable}>
            {contentBody}
        </Container>
    )
}

const mapStateToProps = state => {
    return {
        soccerMatchesState: state.soccerMatchesState,
        selectionState: state.selectionState
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSoccerMatchesState: payload =>
            dispatch({ type: SET_SOCCER_MATCHES_STATE, payload: payload }),
        setSelectionState: payload =>
            dispatch({ type: SET_SELECTION_STATE, payload: payload })
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MatchTable);